import type { ContextualColor, SecondaryColor } from '@/components/sgBootstrapReactWrapper';
import type { RootStatus } from '@/model/mappingCode/rootStatus';
import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';

const colorForRootStatuses: { [status in RootStatus]: ContextualColor | SecondaryColor } = {
  Ac: 'success', // active
  In: 'warning', // inactive
  /* temporary, modify asap*/ Re: 'azure', // reserved
  /* temporary, modify asap*/ EC: 'spicy-mix', // current
};
type Props = {
  rootStatus: RootStatus;
};

const RootStatusBadge = ({ rootStatus }: Props) => {
  return (
    <span
      className={clsx(
        'badge',
        'badge-md',
        'rounded-pill',
        `badge-discreet-${colorForRootStatuses[rootStatus]}`,
      )}
      data-e2e="root-entity-status"
    >
      <FormattedMessage id={`root.status.${String(rootStatus)}`} />
    </span>
  );
};

export default RootStatusBadge;
